import { Component, EventEmitter, Input, Output } from '@angular/core';

import { TranslatePipe } from '@recruitee/i18n';
import type { Invitation } from '@recruitee/invitations-types';
import {
  ButtonComponent,
  DateComponent,
  GroupComponent,
  HeadingComponent,
  IconComponent,
  TruncateComponent,
} from '@recruitee/user-interface';

@Component({
  standalone: true,
  selector: 'rt-invitation-item',
  templateUrl: './invitation-item.component.html',
  styleUrls: ['./invitation-item.component.less'],
  imports: [
    ButtonComponent,
    DateComponent,
    GroupComponent,
    HeadingComponent,
    IconComponent,
    TruncateComponent,
    TranslatePipe,
  ],
})
export class InvitationItemComponent {
  @Input() public invitation: Invitation;
  @Input() public readOnly: boolean;

  @Output() public resendInvitation: EventEmitter<Invitation> = new EventEmitter();
  @Output() public deleteClick: EventEmitter<Invitation> = new EventEmitter();
}
